<template>
  <layout-content>
    <template v-if="toolbar" v-slot:toolbar>
      <toolbar
        :selected="selected"
        :title="toolbar.title || 'Some list'"
        :pageActions="toolbar.pageActions"
        :selectedActions="toolbar.selectedActions"
        :showAccess="toolbar.showAccess"
        :is-filter-changed="isFilterChanged"
        :columns="columns"
        @action="handleAction"
        @filter-up="filterUp"
        @filter="handleAction('filteringTable', $event)"
        @deselect="selected = []"
      />
    </template>
    <template v-if="table" v-slot:main>
      <popup2
        v-if="table.items.length > 0 && type !== 'filter'"
        v-model="showPopup"
        width="428"
      >
        <settings
          v-if="type === 'settings'"
          :fields="table.columns"
          :selected="table.settings"
          @close="showPopup = false"
          @save="handleAction('setSettings', $event)"
        />
        <access
          v-else-if="type === 'access'"
          @close="showPopup = false"
          @save="handleAction('setAccess', $event)"
        />
      </popup2>
      <popup2 v-if="type === 'filter'" v-model="showPopup" width="428">
        <filters
          :show-popup="showPopup"
          :filters="table.filters"
          :empty-filters="table.emptyFilters"
          v-if="type === 'filter'"
          @close="showPopup = false"
          @show-changed="isFilterChanged = $event"
          @save="handleAction('setFilters', $event)"
        />
      </popup2>
      <app-table
        v-if="tableLoaded"
        @setActive="openItem"
        @update="handleAction('filteringTable', $event)"
        v-model="selected"
        :showMobile="true"
        :columns="columns"
        :items="table.items"
        :total="total"
        :loading="table.loading"
        :filter="filter"
      />
    </template>
    <template v-slot:aside>
      <router-view />
    </template>
  </layout-content>
</template>

<script>
import { ref, computed, watch, onMounted } from '@vue/composition-api';
import { Wormhole } from 'portal-vue';
import cloneDeep from 'lodash.clonedeep';
import useDownloadHistory from '@/api/objects/useDownloadHistory';
export default {
  name: 'PageLayoutTable',
  props: {
    toolbar: {
      type: [Object]
    },
    table: {
      type: [Object]
    },
    selectedOut: {
      type: [Array, Object],
      default: () => []
    }
  },
  components: {
    Toolbar: () => import('@/components/appTable/toolbar'),
    LayoutContent: () => import('../layouts/LayoutContent'),
    Settings: () => import('@/components/appTable/settings'),
    Access: () => import('@/components/appTable/access'),
    Filters: () => import('@/components/appTable/filters')
  },
  setup(props, { root, emit }) {
    const tableLoaded = ref(false);
    const showPopup = ref(false);
    const isFilterChanged = ref(false);
    const selected = ref([]);
    const type = ref('');
    const filter = ref(null);
    const total = computed(() => props.table.total);
    const historyComposition = useDownloadHistory();

    const computeWidthColumn = name => {
      switch (name) {
        case 'favourite':
          return '74px';
        case 'enabled':
          return '90px';
        case 'name':
          return '320px';
        case 'deviceEmulation':
          return '74px';
        case 'deviceResponseStatus':
          return '74px';
        case 'deviceBatteryLevel':
          return '90px';
        case 'drivername':
          return '315px';
        case 'muted':
          return '74px';
        case 'online':
          return '74px';
        case 'readergroup':
          return '94px';
        case 'usergroup':
          return '94px';
        case 'editorgroup':
          return '94px';
        default: {
          return '';
        }
      }
    };

    const columns = computed(() => {
      return [
        {
          value: 'data-table-select',
          width: '72px',
          align: 'center',
          text: ''
        },
        ...props.table.columns
          .filter(i => props.table.settings.includes(i.key))
          .map(i => ({
            value: i.key,
            width: computeWidthColumn(i.key),
            text: i.text,
            sortable: i.sortable || i.sortable === undefined,
            showOnMobile: i.showOnMobile
          })),
        {
          value: 'empty',
          width: '100%',
          sortable: false,
          disabled: true,
          text: ''
        }
      ];
    });
    function handleAction(event, data) {
      if (event === 'changeSettings') {
        type.value = 'settings';
        showPopup.value = true;
      } else if (event === 'accessRights') {
        type.value = 'access';
        showPopup.value = true;
      } else if (event === 'delete') {
        emit('event', { event, data: selected.value });
      } else if (event === 'bump-version') {
        emit('event', { event, data: selected.value });
      } else if (event === 'changeSchema') {
        emit('event', { event, data: selected.value });
      } else if (event === 'massiveAccessRights') {
        emit('event', { event, data: selected.value });
      } else if (event === 'massiveDisable') {
        emit('event', { event, data: selected.value });
      } else if (event === 'massiveEnable') {
        emit('event', { event, data: selected.value });
      } else if (event === 'massiveMute') {
        emit('event', { event, data: selected.value });
      } else if (event === 'massiveUnmute') {
        emit('event', { event, data: selected.value });
      } else if (event === 'massiveDisableSchemas') {
        emit('event', { event, data: selected.value });
      } else if (event === 'massiveEnableSchemas') {
        emit('event', { event, data: selected.value });
      } else if (event === 'massiveEnableUsers') {
        emit('event', { event, data: selected.value });
      } else if (event === 'massiveDisableUsers') {
        emit('event', { event, data: selected.value });
      } else if (event === 'downloadHistory') {
        historyComposition.downloadHistory(selected);
      } else if (event === 'downloadLogs') {
        historyComposition.downloadNotificationsHistoryOfObjects(selected);
      } else if (event === 'changeFilters') {
        type.value = 'filter';
        showPopup.value = true;
      } else if (event === 'setFilters') {
        console.log(data)
        console.log(event)
        if (data.length) {
          emit('event', { event, data });
        }
      } else {
        emit('event', { event, data });
      }
    }
    function openItem(v) {
      if (root.$route.params.id !== v.id) {
        Wormhole.close({
          to: 'nested',
          from: 'object'
        });
        let q = cloneDeep(root.$route.query);
        delete q.nestedId;
        root.$router.push({
          name: props.table.itemRoute,
          query: q,
          params: { id: v.id }
        });
      }
    }

    function filterUp(e) {
      filter.value = e;
    }

    watch(
      () => props.table.items,
      newV => {
        const t = newV.map(item => item.id);
        selected.value = selected.value.filter(item => t.includes(item.id));
      }
    );

    onMounted(() => (tableLoaded.value = true));

    return {
      tableLoaded,
      handleAction,
      selected,
      openItem,
      columns,
      showPopup,
      total,
      type,
      filterUp,
      filter,
      isFilterChanged
    };
  }
};
</script>
